import { RecordStatus } from '../menu/enums.types';
import { PermissionLevel, UserPermissionType } from '../public/enum.types';

export interface AppsRequestType {
  name: string;
}

export interface AppsDataResponse {
  id: number;
  appName: string;
  status: RecordStatus;
  createdAt: Date;
  updatedAt: Date;
}

export enum AppTypes {
  MOM = 'mom',
  POS = 'pos',
  MPOS = 'mpos',
  DASHBOARD = 'dashboard',
  ONLINE = 'online',
  KDS = 'kds',
  WEBSITE = 'website',
  QR = 'qr',
  KIOSK = 'kiosk',
  NUGGET = 'nugget',
  KDC = 'kdc',
  TV = 'tv',
  AI = 'ai',
}
interface IAppTypesId {
  [key: string]: number;
}
export const AppTypesId: IAppTypesId = {
  mom: 1,
  pos: 2,
  mpos: 3,
  dashboard: 4,
  online: 5,
  kds: 6,
  website: 7,
  qr: 8,
  kiosk: 9,
};

export enum EnvironmentTypes {
  MOM = 'mom',
  ONLINE = 'online',
  POS = 'pos',
  KDS = 'kds',
  WEBSITE = 'website',
  QR = 'qr',
  MPOS = 'mpos',
  DASHBOARD = 'dashboard',
  KIOSK = 'kiosk',
  WEBDASH = 'web-dash',
}

export interface IFeature {
  label: string;
  id: number;
  key: string;
  Visible: boolean;
  Create?: boolean;
  Read?: boolean;
  Update?: boolean;
  Manager_Approval?: boolean;
  Delete?: boolean;
}

export interface IPermission {
  label: string;
  value?: boolean;
  id: number;
  appId: number;
  appKey: string;
  moduleKey: string;
  features: IFeature[];
}

export interface IPermissionAppsList {
  webDashPermissions: IPermission[];
  mPosPermissions: IPermission[];
  posPermissions: IPermission[];
  momPermissions: IPermission[];
}

export interface IUserPermission {
  roleId?: number;
  userId?: number;
  permissionId?: number;
  appId: number;
  moduleId?: number;
  featureId?: number;
  key: string;
  isGranted: boolean;
  permissionLevel: PermissionLevel;
  status: RecordStatus;
  type: UserPermissionType;
  isApprovalNeeded?: boolean;
  permissionValue?: boolean;
  createdBy?: string;
  updatedBy?: string;
}
export interface PermissionFeature {
  featureName: string;
  id: number;
  key: string;
}

export interface Permission {
  appKey: 'mom' | 'pos' | 'mpos' | 'web-dash';
  moduleName: string;
  moduleId: number;
  appId: number;
  moduleKey: string;
  features: PermissionFeature[];
}

export interface IGetAppPermissionListResponse {
  success: boolean;
  data: IPermissionAppsList;
  message: string;
  error: boolean;
}
export interface IModifiedPermission {
  roleId: number; // Assuming roleId is a string, adjust if needed
  appId: number | null;
  moduleId: number | null;
  featureId: number | null;
  appKey: string;
  featureKey: string | null;
  moduleKey: string;
  permissionType: string; // From permissionNames
  permissionValue: boolean; // Define the type according to what permissionValue holds
  permissionId: number;
  isGrant: boolean;
  isApprovalNeeded: boolean;
}

export interface IRolePermissionData {
  id: number;
  roleId: number;
  roleName?: string;
  payType: string;
  salary: number;
  momPermissions?: IPermission[];
  posPermissions?: IPermission[];
  mPosPermissions?: IPermission[];
  webDashPermissions?: IPermission[];
  modifiedMomPermission?: IModifiedPermission[];
  modifiedPosPermission?: IModifiedPermission[];
  modifiedMPosPermission?: IModifiedPermission[];
  modifiedWebDashPermission?: IModifiedPermission[];
  originalMomData?: IPermission[];
  originalPosData?: IPermission[];
  originalMposData?: IPermission[];
  originalWebDashData?: IPermission[];
}
export interface IUserPermissionData {
  id: number;
  roleId: number;
  userId: string;
  permissionId: number;
  appId: number;
  moduleId: number;
  featureId: number;
  key: string;
  isGranted: boolean;
  isApprovalNeeded: boolean;
  permissionLevel: PermissionLevel;
  type: UserPermissionType;
  status: RecordStatus;
  createdAt: Date; // If handling dates, you can also use `Date` type
  updatedAt: Date; // If handling dates, you can also use `Date` type
  deletedAt: Date;
  createdBy: string;
  updatedBy: string;
  deletedBy: string;
  permissionValue: boolean;
  approvedPermissions: any;
  permission: any;
  locked: boolean;
}

export interface IUserPermissionUIPermission {
  roleId?: number;
  userId?: number;
  permissionId: number;
  appId: number;
  moduleId: number;
  featureId: number | null;
  key: string;
  isGranted: boolean;
  permissionLevel: PermissionLevel;
  status: RecordStatus;
  type: UserPermissionType;
  isApprovalNeeded?: boolean;
  permissionValue?: boolean;
}
export interface IPermissionData {
  id: number;
  appKey: 'mom' | 'pos' | 'mpos' | 'web-dash';
  moduleName: string;
  moduleId: number;
  appId: number;
  moduleKey: string;
  features: PermissionFeature[];
}

export enum CreatedByUser {
  SYSTEM = 'System',
}
